import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { resetGameSettingsResponseSchema } from '../types';

export type ResetGameSettingsMutationParams = {
	gameId: number;
	accountId: number;
	currency: string;
};

export const createResetGameSettingsMutation = () =>
	createAuthMutation({
		params: declareParams<ResetGameSettingsMutationParams>(),
		request: {
			method: 'PATCH',
			url: '/games-settings/reset',
			body: (data) => data,
		},
		response: {
			contract: zodContract(resetGameSettingsResponseSchema.array()),
		},
	});
